var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2301_1259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2301_1259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 22.6667C16.3781 22.6667 16.6948 22.539 16.9503 22.2834C17.2059 22.0279 17.3337 21.7112 17.3337 21.3334C17.3337 20.9556 17.2059 20.639 16.9503 20.3834C16.6948 20.1279 16.3781 20.0001 16.0003 20.0001C15.6225 20.0001 15.3059 20.1279 15.0503 20.3834C14.7948 20.639 14.667 20.9556 14.667 21.3334C14.667 21.7112 14.7948 22.0279 15.0503 22.2834C15.3059 22.539 15.6225 22.6667 16.0003 22.6667ZM14.667 17.3334H17.3337V9.33341H14.667V17.3334ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334ZM16.0003 26.6667C18.9781 26.6667 21.5003 25.6334 23.567 23.5667C25.6337 21.5001 26.667 18.9779 26.667 16.0001C26.667 13.0223 25.6337 10.5001 23.567 8.43341C21.5003 6.36675 18.9781 5.33341 16.0003 5.33341C13.0225 5.33341 10.5003 6.36675 8.43366 8.43341C6.36699 10.5001 5.33366 13.0223 5.33366 16.0001C5.33366 18.9779 6.36699 21.5001 8.43366 23.5667C10.5003 25.6334 13.0225 26.6667 16.0003 26.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.ac794d559d5f9033153a13dae4fd5b27.svg";
export { ForwardRef as ReactComponent };